import { createAction, props } from '@ngrx/store';
import { ClubRequests } from './club-requests.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch record club requests'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch record club requests success', 
    props<{ listData: ClubRequests[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch record club requests failure', 
    props<{ error: string }>()
);

// Mark AS Handled
export const markHandled = createAction(
    '[Data] Mark handled club requests requests',
    props<{ id: string }>()
);
export const  markHandledSuccess = createAction(
    '[Data] Mark handled club requests success'
);
export const markHandledFailure = createAction(
    '[Data] Mark handled club requests failure',
    props<{ error: string }>()
);

//Fetch Count
export const fetchSportlinkRequestCount = createAction(
    '[Data] Fetch total count for club requests'
);
export const  fetchSportlinkRequestCountSuccess = createAction(
    '[Data] Fetch total count for club requests success'
);
export const fetchSportlinkRequestCountFailures = createAction(
    '[Data] Fetch total count for club requests failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state club requests',
);